// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"301d1171","381":"1a4dc034","453":"8164420b","584":"a07cc7ed","801":"4375de9b"}[chunkId] + ".chunk.js";
};